























































import { ref, computed, defineComponent } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  name: 'CarePlanDrawer',
  props: {
    careplanInfoHTML: { type: String, default: '' },
    image: { type: String, default: '' },
    productName: { type: String, default: '' },
    careplanPrice: { type: Number, default: 0 },
    isCareplanApplied: { type: Boolean, default: false },
    isOpen: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const { translate } = useTranslations();
    const formatUrl = useUrlFormatter();

    const isApplyClicked = ref(false);

    const closeDrawer = () => {
      emit('close');
    };

    const applyCareplan = () => {
      isApplyClicked.value = true;

      emit('apply');

      setTimeout(() => {
        isApplyClicked.value = false;
        closeDrawer();
      }, 1000);
    };

    const applyButtonClass = computed(() => ({
      'animated-hidden-button-container': props.isCareplanApplied && isApplyClicked.value,
      'hidden-button-container': props.isCareplanApplied && !isApplyClicked.value
    }));

    return {
      applyButtonClass,
      closeDrawer,
      formatUrl,
      applyCareplan,
      isApplyClicked,
      translate
    };
  }
});
